import { setLocalStorage } from '../../../../helpers/storage'

export const onAuthLinkClickHandler = () => {
  // save the destination URL which could be used for redirection after authentication
  // this localStorage property is used on auth-callback page and is cleaned up after redirection
  setLocalStorage('authTriggeringUrl', window.location.pathname)
}
